import React, { memo } from 'react'
import type { PropsWithChildren } from 'react'
import Font from 'react-font'

import styles from './Title.module.css'
const Title: React.FC<PropsWithChildren> = memo(({ children }) => {
  return (
    <Font family="Nunito">
      <h2 className="text-brand-dark mx-auto text-center p-6 text-3xl md:text-4xl font-bold">
        <span className={styles.title}>{children}</span>
      </h2>
    </Font>
  )
})
Title.displayName = 'Title'

export default Title
